import { useState, forwardRef } from "react";
import ImageCroppSO, {
  ImageCroppRef,
} from "src/Components/ImageCropp/ImageCropp";
import { Box } from "@mui/material";
import __ from "src/utils/Translations";
import { Dropzone, DropzoneFile } from "@benefit-systems/hr-tools-ui";

interface ImageUploadProps {
  onImageCropped: (image: string | Blob) => void;
}

const ImageUpload = forwardRef<ImageCroppRef, ImageUploadProps>(
  ({ onImageCropped }, ref) => {
    const [image, setImage] = useState<string | null>(null);

    const handleFilesAccepted = (files: DropzoneFile[]) => {
      const validFiles = files.filter((f) => f.isValid);

      if (validFiles.length > 0) {
        const reader = new FileReader();
        reader.onload = (e) => {
          if (e.target?.result) {
            setImage(e.target.result as string);
          }
        };
        reader.readAsDataURL(validFiles[0].file);
      }
    };

    return image ? (
      <Box sx={{ maxWidth: 286 }}>
        <ImageCroppSO
          ref={ref}
          croppieConfig={{
            viewport: { width: 286, height: 286, type: "circle" },
          }}
          image={image}
          outputSize={{ width: 256, height: 256 }}
          outputType="base64"
          onSave={(croppedImage) => {
            onImageCropped(croppedImage);
          }}
          onDelete={() => setImage(null)}
        />
      </Box>
    ) : (
      <Box sx={{ marginTop: 2 }}>
        <Dropzone
          onFilesAccepted={handleFilesAccepted}
          activeLinkText={__("Dodaj zdjęcie z dysku")}
          maxFiles={1}
          maxFileSize={5}
          showInlineErrors
          showInvalidFiles
        />
      </Box>
    );
  }
);

export default ImageUpload;
